import { INDETERMINATE } from '../constants';

export const customRemindHours = [48, 72, 96];
export const maxHours = 24;

export const isTimeIndeterminate = time => !!time && (time.hours === INDETERMINATE || time.minutes === INDETERMINATE);

export const shouldUpdateSecondReminder = (firstReminderTime, secondReminderTime) => {
  if (
    !firstReminderTime || !secondReminderTime ||
    isTimeIndeterminate(firstReminderTime) || isTimeIndeterminate(secondReminderTime)
  ) {
    return false;
  }

  const firstReminderTimeHours = Number(firstReminderTime.hours);
  const firstReminderTimeMinutes = Number(firstReminderTime.minutes);
  const secondReminderTimeHours = Number(secondReminderTime.hours);
  const secondReminderTimeMinutes = Number(secondReminderTime.minutes);

  if (firstReminderTimeHours === secondReminderTimeHours) {
    return firstReminderTimeMinutes <= secondReminderTimeMinutes;
  }

  return firstReminderTimeHours < secondReminderTimeHours;
};

export const getUpdatedSecondReminder = (firstReminderTime, minuteOptions) => {
  const firstReminderHours = Number(firstReminderTime.hours);
  const firstReminderMinutes = Number(firstReminderTime.minutes);
  const minutes = minuteOptions[minuteOptions.indexOf(firstReminderMinutes) - 1] || 0;
  const hours = firstReminderMinutes ? firstReminderHours : firstReminderHours - 1;

  return { hours, minutes };
};

export const getSecondReminderMaxHours = (firstReminderTime) => {
  if (isTimeIndeterminate(firstReminderTime)) {
    return { hours: maxHours, minutes: 5 };
  }

  return { ...firstReminderTime, hours: Math.min(firstReminderTime.hours, maxHours) };
};

export const getSecondReminderCustomHours = (firstReminderTime) => {
  if (isTimeIndeterminate(firstReminderTime)) {
    return customRemindHours;
  }

  return customRemindHours.filter(hour => hour < firstReminderTime.hours);
};

/* eslint-disable no-param-reassign */
export const mergeLocationReminderTimeToAll = (allLocationsReminderTime, locationReminderTime) => {
  if (allLocationsReminderTime.hours === null) {
    allLocationsReminderTime.hours = locationReminderTime.hours;
  } else if (allLocationsReminderTime.hours !== locationReminderTime.hours) {
    allLocationsReminderTime.hours = INDETERMINATE;
  }
  if (allLocationsReminderTime.minutes === null) {
    allLocationsReminderTime.minutes = locationReminderTime.minutes;
  } else if (allLocationsReminderTime.minutes !== locationReminderTime.minutes) {
    allLocationsReminderTime.minutes = INDETERMINATE;
  }
};
/* eslint-enable no-param-reassign */

export const firstReminderFieldName = (formSectionName, name) => `${formSectionName}.${name}.barber_reminder.time`;
export const secondReminderFieldName = (formSectionName, name) => `${formSectionName}.${name}.reminder.time`;
